import { useEffect, useState } from "react";

const TimeDisplay = () => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (date: Date) => {
    return date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  };

  const formatDate = (date: Date) => {
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: '2-digit',
      year: 'numeric',
      weekday: 'long'
    });
  };

  return (
    <div className="text-center py-6">
      <div className="text-4xl md:text-5xl font-light text-time-display mb-2">
        {formatTime(currentTime)}
      </div>
      <div className="text-sm text-time-secondary">
        {formatDate(currentTime)}
      </div>
    </div>
  );
};

export default TimeDisplay;